<div *ngIf="alert" class="a-fx-col a-fx-gap-16">
    <div>
        <div class="h5" [innerHTML]="alert.title"></div>

        <div [innerHTML]="alert.message"></div>
    </div>

    <adspt-accordion *ngIf="alert.listItems?.length" #accordion>
        <div
            *adsptAccordionHeader
            adsptAccordionToggle
            class="list-header a-fx a-fx-start-center a-fx-gap-8 a-cursor-pointer"
        >
            <adspt-icon name="caret-down" [class.rotate]="!accordion.expanded" />

            <span>
                {{ 'alert-center.instance.show-affected' | translate }}
            </span>
        </div>

        <ul *adsptAccordionExpandedContent>
            <li *ngFor="let item of alert.listItems; trackBy: trackByListItem" [ngSwitch]="!!item.link">
                <div *ngSwitchCase="false" [innerHTML]="item.text"></div>

                <a *ngSwitchCase="true" [href]="item.link" [innerHTML]="item.text"></a>
            </li>
        </ul>
    </adspt-accordion>
</div>
